import React from 'react';
import { motion } from 'framer-motion';
const situations = [{
  emoji: '😰',
  title: 'El Desorden que No Para',
  desc: 'Tenés papeles sueltos, carpetas sin orden y archivos digitales guardados "donde salió". Cada vez que necesitás algo urgente, perdés más tiempo del que deberías.'
}, {
  emoji: '😩',
  title: 'Los Cobros que se Escapan',
  desc: 'Sabés que hay pacientes que te deben sesiones pero no tenés registro claro de cuánto ni cómo decírselo sin incomodar el vínculo terapéutico.'
}, {
  emoji: '📱',
  title: 'El Miedo a ARCA',
  desc: 'Cada vez que llega un mail de ARCA algo en tu cuerpo se tensa. No sabés si tu categoría de Monotributo está bien, si pagaste todo a tiempo o si hay algo que se te está escapando.'
}, {
  emoji: '📉',
  title: 'La Exposición Legal Invisible',
  desc: 'Tenés consentimientos firmados de algunos pacientes. De otros no. Y en el fondo sabés que eso es un riesgo real ante cualquier auditoría del Colegio de Psicólogos.'
}];
export function ProblemSection() {
  return <section className="py-12 md:py-16 bg-transparent" data-id="element-168">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-169">
        <div className="text-center mb-10" data-id="element-170">
          <h2 className="font-heading text-3xl md:text-5xl font-bold mb-4 text-[#2f3a2c]" data-id="element-171">
            ¿TE RECONOCES EN ESTO?
          </h2>
          <p className="text-xl font-bold text-[#6f7a64] mb-4 italic" data-id="element-172">
            ¿La parte administrativa de tu consultorio se convirtió en una carga
            que no podés ignorar pero tampoco podés resolver?
          </p>
          <p className="text-lg text-slate-600 leading-relaxed max-w-2xl mx-auto" data-id="element-173">
            Si sos psicólogo independiente en Argentina, seguramente conocés
            alguna de estas situaciones:
          </p>
        </div>

        <div className="grid sm:grid-cols-2 gap-6" data-id="element-174">
          {situations.map((item, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-white p-6 rounded-2xl shadow-sm border border-slate-200" data-id="element-175">
              <div className="text-3xl mb-3" data-id="element-176">{item.emoji}</div>
              <h3 className="text-lg font-bold text-[#2f3a2c] mb-2" data-id="element-177">
                {item.title}
              </h3>
              <p className="text-slate-600 leading-relaxed" data-id="element-178">{item.desc}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}